/* Rosela Nightly review widget.

   Data lives in five theme assets, all reached from the manifest URL on the section:
     nightly-reviews.json        aggregate + title/photo lists + the names of the other files
     nightly-reviews-names.json  reviewer name dictionary
     nightly-reviews-seg.json    sentence dictionary
     nightly-reviews-N.json      the rows, split into pages

   Rows are [stars, verified, dayOffset, nameIndex, titleIndex, bodyTokens, photoIndex].
   bodyTokens mixes ints (an index into the sentence dictionary) with literal strings, and
   the body is those parts joined by a single space. That dictionary is what lets 892 rows
   travel in about 90KB instead of 280KB.

   Nothing is fetched until the section is near the viewport OR the browser goes idle,
   whichever comes first. The idle fallback matters: a hidden or prerendered tab never
   fires IntersectionObserver, and without it the section would sit empty forever. */
(function () {
  var PAGE = 8;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function stars(n) { return '★'.repeat(n) + '☆'.repeat(5 - n); }
  function sibling(src, name) {
    var q = src.indexOf('?');
    return (q > -1 ? src.slice(0, q) : src).replace(/[^/]+$/, name);
  }
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function dateFor(baseMs, day) {
    var d = new Date(baseMs + day * 86400000);
    return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
  }

  function boot(root) {
    if (root.dataset.nrReady) return;
    root.dataset.nrReady = '1';

    var src = root.dataset.src;
    var q = {
      score: root.querySelector('[data-nr-score]'),
      stars: root.querySelector('[data-nr-stars]'),
      count: root.querySelector('[data-nr-count]'),
      bars: root.querySelector('[data-nr-bars]'),
      photos: root.querySelector('[data-nr-photos]'),
      list: root.querySelector('[data-nr-list]'),
      showing: root.querySelector('[data-nr-showing]'),
      sort: root.querySelector('[data-nr-sort]'),
      search: root.querySelector('[data-nr-search]'),
      chips: root.querySelector('[data-nr-chips]'),
      sentinel: root.querySelector('[data-nr-sentinel]'),
      more: root.querySelector('[data-nr-more]'),
      status: root.querySelector('[data-nr-status]')
    };

    var data = null, all = [], view = [], shown = 0;
    var filterStars = 0, onlyPhotos = false, term = '';

    function load() {
      if (root.dataset.nrLoading) return;
      root.dataset.nrLoading = '1';
      if (q.status) q.status.textContent = 'Loading reviews…';

      fetch(src).then(function (r) { return r.json(); }).then(function (m) {
        data = m;
        summary();
        return Promise.all([
          fetch(sibling(src, m.names_url)).then(function (r) { return r.json(); }),
          fetch(sibling(src, m.seg_url)).then(function (r) { return r.json(); })
        ].concat(m.pages.map(function (p) {
          return fetch(sibling(src, p)).then(function (r) { return r.json(); });
        })));
      }).then(function (parts) {
        var names = parts[0], seg = parts[1];
        var photoUrls = (data.photos || []).map(function (f) { return sibling(src, f); });
        var baseMs = Date.parse(data.base + 'T00:00:00Z');
        var rows = [];
        for (var p = 2; p < parts.length; p++) rows = rows.concat(parts[p]);

        all = rows.map(function (r, i) {
          var body = '';
          for (var t = 0; t < r[5].length; t++) {
            body += (t ? ' ' : '') + (typeof r[5][t] === 'number' ? seg[r[5][t]] : r[5][t]);
          }
          return {
            i: i,
            stars: r[0],
            verified: !!r[1],
            day: r[2],
            when: dateFor(baseMs, r[2]),
            name: names[r[3]],
            title: data.titles[r[4]],
            body: body,
            hay: (names[r[3]] + ' ' + data.titles[r[4]] + ' ' + body).toLowerCase(),
            photo: r[6] >= 0 ? photoUrls[r[6]] : null
          };
        });

        if (q.status) q.status.textContent = '';
        photos();
        paint(true);
        wire();
      }).catch(function () {
        if (q.status) q.status.textContent = 'Reviews could not be loaded right now.';
      });
    }

    function summary() {
      if (q.score) q.score.textContent = data.average.toFixed(2);
      if (q.stars) q.stars.textContent = stars(Math.round(data.average));
      if (q.count) {
        q.count.textContent = 'Based on ' + data.total.toLocaleString() + ' reviews' +
          (data.verified ? ' · ' + data.verified.toLocaleString() + ' verified' : '');
      }
      bars();
    }

    function bars() {
      if (!q.bars) return;
      q.bars.textContent = '';
      [5, 4, 3, 2, 1].forEach(function (s) {
        var n = data.distribution[s] || 0;
        var pct = data.total ? (n / data.total * 100) : 0;
        var b = el('button', 'nr__bar');
        b.type = 'button';
        b.setAttribute('aria-pressed', String(filterStars === s));
        b.setAttribute('aria-label', n.toLocaleString() + ' reviews with ' + s + ' stars');
        b.appendChild(el('span', null, String(s)));
        var track = el('span', 'nr__track');
        var fill = el('span', 'nr__fill');
        fill.style.width = pct.toFixed(1) + '%';
        track.appendChild(fill);
        b.appendChild(track);
        b.appendChild(el('span', 'nr__n', n.toLocaleString()));
        b.addEventListener('click', function () {
          filterStars = (filterStars === s) ? 0 : s;
          bars(); chips(); paint(true);
        });
        q.bars.appendChild(b);
      });
    }

    function photos() {
      if (!q.photos) return;
      var withPhoto = all.filter(function (r) { return r.photo; });
      q.photos.textContent = '';
      if (!withPhoto.length) return;
      q.photos.appendChild(el('h3', null, 'Customer photos'));
      var grid = el('div', 'nr__grid');
      withPhoto.slice(0, 24).forEach(function (r) {
        var btn = el('button', 'nr__ph-btn');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Open photo from ' + r.name);
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = r.photo;
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', function () { lightbox(r); });
        grid.appendChild(btn);
      });
      q.photos.appendChild(grid);
    }

    function lightbox(r) {
      var wrap = el('div', 'nr__lb');
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('aria-label', 'Review photo');
      var box = el('div', 'nr__lb-box');
      var close = el('button', 'nr__lb-x', '×');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close');
      var img = document.createElement('img');
      img.src = r.photo;
      img.alt = '';
      box.appendChild(close);
      box.appendChild(img);
      var cap = el('div', 'nr__lb-cap');
      cap.appendChild(el('span', 'nr__rs', stars(r.stars)));
      cap.appendChild(el('strong', null, r.name));
      cap.appendChild(el('p', null, r.body));
      box.appendChild(cap);
      wrap.appendChild(box);
      document.body.appendChild(wrap);
      function shut() { wrap.remove(); document.removeEventListener('keydown', key); }
      function key(e) { if (e.key === 'Escape') shut(); }
      close.addEventListener('click', shut);
      wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
      document.addEventListener('keydown', key);
      close.focus();
    }

    function pool() {
      var r = all.slice();
      if (filterStars) r = r.filter(function (x) { return x.stars === filterStars; });
      if (onlyPhotos) r = r.filter(function (x) { return x.photo; });
      if (term) r = r.filter(function (x) { return x.hay.indexOf(term) > -1; });
      var s = q.sort ? q.sort.value : 'recent';
      r.sort(function (a, b) {
        if (s === 'oldest') return a.day - b.day || a.i - b.i;
        if (s === 'highest') return b.stars - a.stars || b.day - a.day;
        if (s === 'lowest') return a.stars - b.stars || b.day - a.day;
        return b.day - a.day || a.i - b.i;
      });
      return r;
    }

    function chips() {
      if (!q.chips) return;
      q.chips.textContent = '';
      var active = [];
      if (filterStars) active.push({ label: filterStars + ' star only', clear: function () { filterStars = 0; bars(); } });
      if (onlyPhotos) active.push({ label: 'With photos', clear: function () {
        onlyPhotos = false;
        var t = root.querySelector('[data-nr-photos-only]');
        if (t) t.setAttribute('aria-pressed', 'false');
      } });
      if (term) active.push({ label: '“' + term + '”', clear: function () { term = ''; if (q.search) q.search.value = ''; } });
      active.forEach(function (a) {
        var c = el('button', 'nr__chip');
        c.type = 'button';
        c.appendChild(el('span', null, a.label));
        c.appendChild(el('span', 'nr__chip-x', '×'));
        c.setAttribute('aria-label', 'Remove filter: ' + a.label);
        c.addEventListener('click', function () { a.clear(); chips(); paint(true); });
        q.chips.appendChild(c);
      });
      q.chips.hidden = active.length === 0;
    }

    function row(r) {
      var li = el('li', 'nr__item');
      var head = el('div', 'nr__head');
      head.appendChild(el('span', 'nr__rs', stars(r.stars)));
      head.appendChild(el('span', 'nr__who', r.name));
      if (r.verified) head.appendChild(el('span', 'nr__vf', '✓ Verified'));
      head.appendChild(el('span', null, r.when));
      li.appendChild(head);
      if (r.title) li.appendChild(el('p', 'nr__title', r.title));
      li.appendChild(el('p', 'nr__body', r.body));
      if (r.photo) {
        var btn = el('button', 'nr__ph-btn nr__ph-btn--sm');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Open photo from ' + r.name);
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = r.photo;
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', function () { lightbox(r); });
        li.appendChild(btn);
      }
      return li;
    }

    function paint(reset) {
      if (reset) { q.list.textContent = ''; shown = 0; view = pool(); }
      var next = view.slice(shown, shown + PAGE);
      var frag = document.createDocumentFragment();
      next.forEach(function (r) { frag.appendChild(row(r)); });
      q.list.appendChild(frag);
      shown += next.length;

      if (reset && !view.length) {
        q.list.appendChild(el('li', 'nr__empty', 'No reviews match that. Try clearing a filter.'));
      }
      if (q.showing) {
        q.showing.textContent = view.length
          ? 'Showing ' + shown + ' of ' + view.length.toLocaleString() +
            (view.length === data.total ? '' : ' matching') + ' reviews'
          : '';
      }
      if (q.more) {
        q.more.textContent = (shown >= view.length && view.length)
          ? 'That is all ' + view.length.toLocaleString() + '.'
          : '';
      }
    }

    var debounce;
    function wire() {
      if (q.sort) q.sort.addEventListener('change', function () { paint(true); });
      if (q.search) {
        q.search.addEventListener('input', function () {
          clearTimeout(debounce);
          debounce = setTimeout(function () {
            term = q.search.value.trim().toLowerCase();
            chips(); paint(true);
          }, 180);
        });
      }
      var pt = root.querySelector('[data-nr-photos-only]');
      if (pt) {
        pt.addEventListener('click', function () {
          onlyPhotos = !onlyPhotos;
          pt.setAttribute('aria-pressed', String(onlyPhotos));
          chips(); paint(true);
        });
      }
      if (q.sentinel && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          if (e[0].isIntersecting && shown < view.length) paint(false);
        }, { rootMargin: '500px' }).observe(q.sentinel);
      }
    }

    var io = null;
    function kick() { if (io) { io.disconnect(); io = null; } load(); }

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) kick();
      }, { rootMargin: '800px' });
      io.observe(root);
    }
    /* Belt and braces. A hidden, prerendered or background tab never fires the observer,
       and an empty review section is worse than a slightly early fetch. */
    if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 2500 });
    else setTimeout(kick, 1500);
  }

  function go() { document.querySelectorAll('[data-nightly-reviews]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
  document.addEventListener('shopify:section:load', go);
})();
